import { render } from "./JessibucaDemo.vue?vue&type=template&id=ce41f27a&ts=true"
import script from "./JessibucaDemo.vue?vue&type=script&lang=ts"
export * from "./JessibucaDemo.vue?vue&type=script&lang=ts"

import "./JessibucaDemo.vue?vue&type=style&index=0&id=ce41f27a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__